"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledOrdersLists = exports.StyledOrdersTabs = exports.StyledOrdersTab = exports.StyledOverflowContainer = exports.StyledRowFlex = exports.StyledBoxWithDetails = exports.StyledSmallTextDetail = exports.StyledSmallTitle = exports.StyledOneLineText = exports.textOverflow = exports.StyledBorderWrapper = exports.StyledColumnFlex = exports.StyledText = exports.StyledShadowContainer = void 0;
var material_1 = require("@mui/material");
exports.StyledShadowContainer = (0, material_1.styled)(material_1.Box)({
    boxShadow: "0px 5px 20px rgba(85, 94, 104, 0.13)",
    borderRadius: 25,
    minWidth: 121,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: 5,
    "& p": {
        fontSize: 12,
        fontWeight: 600,
    },
});
exports.StyledText = (0, material_1.styled)(material_1.Typography)({
    fontFamily: "inherit",
    fontSize: "inherit",
});
exports.StyledColumnFlex = (0, material_1.styled)(material_1.Box)(function (_a) {
    var _b = _a.gap, gap = _b === void 0 ? 10 : _b;
    return ({
        display: "flex",
        flexDirection: "column",
        gap: gap,
        alignItems: "flex-start",
        width: "100%",
    });
});
exports.StyledBorderWrapper = (0, material_1.styled)(material_1.Box)({
    display: "flex",
    alignItems: "center",
    height: 58,
    border: "1px solid #EAECF0",
    boxShadow: "0px 12px 60px rgba(141, 155, 170, 0.1)",
    borderRadius: 30,
    padding: 8,
});
exports.textOverflow = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
};
exports.StyledOneLineText = (0, material_1.styled)(exports.StyledText)(__assign(__assign({}, exports.textOverflow), { minWidth: 0 }));
exports.StyledSmallTitle = (0, material_1.styled)(exports.StyledOneLineText)({
    fontWeight: 600,
    fontSize: 12,
});
exports.StyledSmallTextDetail = (0, material_1.styled)(material_1.Typography)({
    fontWeight: 400,
    fontSize: "12px",
});
exports.StyledBoxWithDetails = (0, material_1.styled)(exports.StyledColumnFlex)({
    gap: 10,
});
exports.StyledRowFlex = (0, material_1.styled)(material_1.Box)(function (_a) {
    var _b = _a.gap, gap = _b === void 0 ? 10 : _b, _c = _a.justifyContent, justifyContent = _c === void 0 ? "center" : _c, _d = _a.width, width = _d === void 0 ? "100%" : _d;
    return ({
        display: "flex",
        alignItems: "center",
        justifyContent: justifyContent,
        width: width,
        gap: gap,
    });
});
exports.StyledOverflowContainer = (0, material_1.styled)(exports.StyledRowFlex)(__assign(__assign({}, exports.textOverflow), { justifyContent: "flex-start" }));
exports.StyledOrdersTab = (0, material_1.styled)(material_1.Tab)({
    fontSize: 13,
    width: "calc(100% / 4)",
    padding: "0px",
    textTransform: "unset",
    fontFamily: "inherit",
    "@media(max-width: 600px)": {
        padding: "0px 6px!important",
        width: "unset",
    },
});
exports.StyledOrdersTabs = (0, material_1.styled)(material_1.Tabs)({
    border: "1px solid #202432",
    width: "100%",
    borderRadius: 6,
    padding: 3,
    "& .MuiTabs-indicator": {
        height: "100%",
        zIndex: 1,
    },
    "& .MuiTouchRipple-root": {},
    "& .MuiButtonBase-root": {
        zIndex: 9,
    },
    "& .Mui-selected": {},
});
exports.StyledOrdersLists = (0, material_1.styled)(material_1.Box)({
    overflow: "auto",
    height: "100%",
});
